import { ACTIONS_NAMESPACE } from "../consts";

const actionTypes = {
  RECEIVE_USER_COURSE_STATS: `${ACTIONS_NAMESPACE}RECEIVE_USER_COURSE_STATS`
};

export default actionTypes;
